export const name = {
    'en': 'davinci',
    'zh-tw': '達哥AI'
};

export const sendDavinci = {
    'en': 'send message [VALUE] to davinci',
    'zh-tw': '送出訊息[VALUE]到達哥AI'
};

export const davinci_apikey = {
    'en': 'api key [KEY',
    'zh-tw': 'api 金鑰:[KEY]'
};
export const assistant_id={
    'en': 'asssistant id: [ID]',
    'zh-tw': ' 助理 ID:[ID]'
};

export const ananswer ={
    'en': 'response',
    'zh-tw': 'AI回應訊息'
};

export const copyTEXT_memory ={
    'en': 'copy [TEXT]to clipboard',
    'zh-tw': '複製[TEXT]到剪貼簿'
};

export const api_assistant_error={
    'en': 'api key or assistant_id error',
    'zh-tw': '金鑰或助理ID錯誤'
};

export const thread_id_error={
    'en': 'thread.id error. check api key or assistant_id',
    'zh-tw': 'thread.id錯誤，檢查金鑰或助理ID'
}